import { Container, SearchBar } from '@shared';

import { ErrorContainer, ErrorTextContainer, Wrapper } from './styled';

const ShopAndFly404 = ({
  errorTextFirstLine = 'Sayfa Bulunamadı,',
  errorTextSecondLine = 'Aradığınız sayfaya ulaşılamıyor. Lütfen sayfa adresini kontrol edip yeniden deneyin.',
}) => {
  return (
    <Wrapper>
      <Container>
        <SearchBar />
        <ErrorContainer>
          <ErrorTextContainer>
            <img src='/static/images/icon-404.webp' alt='Sayfa bulunamadı' />
            <h5>
              {errorTextFirstLine} <br />
            </h5>
            <p>{errorTextSecondLine}</p>
          </ErrorTextContainer>
        </ErrorContainer>
      </Container>
    </Wrapper>
  );
};

export default ShopAndFly404;
